import { render, staticRenderFns } from "./RlsOperation.vue?vue&type=template&id=72f47850&scoped=true&"
import script from "./RlsOperation.vue?vue&type=script&lang=js&"
export * from "./RlsOperation.vue?vue&type=script&lang=js&"
import style0 from "./RlsOperation.vue?vue&type=style&index=0&id=72f47850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f47850",
  null
  
)

export default component.exports